import { INotification, INotificationDto } from "../types/Notification";

export const toNotification = (dto: INotificationDto): INotification => ({
  id: dto.id,
  title: dto.title,
  description: dto.text,
  image: dto.image_url || undefined,
  clickUrl: dto.click_url || undefined,
  createdAt: dto.received_at,
  isRead: dto.is_read,
});
